import 'slick-carousel';
import '../../themes/home.css'

jQuery(async function () {
	$('.home .slick-carousel').slick({
		dots: true,
		arrows: true,
		infinite: false,
		autoplay: false,
		speed: 300,
		slidesToShow: 4,
		touchThreshold: 1000,
		slidesToScroll: 4,
		//lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
		]
	});
	$('.exclusivos-carousel').slick({
		dots: true,
		arrows: true,
		infinite: false,
		autoplay: false,
		speed: 300,
		slidesToShow: 3,
		touchThreshold: 1000,
		slidesToScroll: 4,
		//lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}
		]
	});

	$('.blog-carousel').slick({
		dots: true,
		arrows: true,
		infinite: false,
		autoplay: false,
		speed: 300,
		slidesToShow: 4,
		touchThreshold: 1000,
		slidesToScroll: 4,
		//lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
		]
	});
});

/* Efeito Natal*/

// $(document).ready(function () {

// 	if(sessionStorage.getItem('animacaoNatal') != "true"){
// 		const maxVisibleSnowflakes = 20; // Máximo de flocos visíveis na tela
// 		const snowflakesOnScreen = []; // Lista para rastrear os flocos visíveis
// 		let heights = [50, 40, 30];
		
// 		const snowflakeSVG = `
// 			<?xml version="1.0" encoding="iso-8859-1"?> <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"> <svg fill="#fff" height="50px" width="50px" stroke="#000" stroke-width="2"  stroke-opacity="0.5" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 298 298" xml:space="preserve"> <g> <path d="M289.5,140.5h-24.606l11.031-11.03c2.93-2.929,2.93-7.678,0.001-10.606c-2.929-2.929-7.678-2.93-10.606-0.001 L243.681,140.5h-36.369l16.182-17.392c2.821-3.032,2.65-7.777-0.383-10.6c-1.243-1.156-2.775-1.802-4.345-1.961 c-0.952-0.047-21.495-0.003-21.495-0.003L221.315,86.5H251.5c4.143,0,7.5-3.357,7.5-7.5s-3.357-7.5-7.5-7.5h-15.186l17.69-17.69 c2.929-2.93,2.929-7.678,0-10.608c-2.93-2.928-7.844-2.928-10.774,0L225.167,61.1V45.5c0-4.143-3.357-7.5-7.5-7.5 c-4.143,0-7.5,3.357-7.5,7.5v30.601l-24.837,25.004l-0.415-22.645c-0.001-0.036,0.035-0.07,0.034-0.106 c-0.035-1.824-0.704-3.641-2.07-5.059c-2.873-2.982-7.778-3.07-10.761-0.194l-15.951,15.226V53.107l21.47-21.304 c2.929-2.93,3.012-7.678,0.083-10.607c-2.93-2.928-7.803-2.928-10.732,0l-10.821,10.696V7.5c0-4.143-3.357-7.5-7.5-7.5 c-4.143,0-7.5,3.357-7.5,7.5v24.393l-10.53-10.696c-2.93-2.928-7.594-2.928-10.524,0c-2.929,2.93-3.054,7.678-0.125,10.607 l21.179,21.304v35.421l-16.176-15.475c-3.009-2.847-7.67-2.718-10.52,0.289c-1.075,1.136-1.683,2.52-1.914,3.955 c-0.142,0.583-0.203,1.188-0.201,1.811l-0.088,21.229l-25.1-24.944V45.5c0-4.143-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5v14.894 L55.142,43.202c-2.93-2.928-7.594-2.928-10.524,0c-2.929,2.93-2.887,7.678,0.042,10.608L62.392,71.5H46.5 c-4.143,0-7.5,3.357-7.5,7.5s3.357,7.5,7.5,7.5h30.892l24.744,24.744l-23.057,0.831c-4.021,0.146-7.524,3.435-7.563,7.418 c-0.004,0.112-0.349,0.225-0.349,0.337c0,0.003,0,0.007,0,0.011c0,0.008,0.345,0.017,0.345,0.024 c0.045,1.875,0.955,3.736,2.395,5.158L89.748,140.5H55.025l-21.638-21.638c-2.93-2.928-7.678-2.928-10.607,0 c-2.929,2.93-2.929,7.678,0,10.607l11.03,11.03H8.5c-4.143,0-7.5,3.357-7.5,7.5s3.357,7.5,7.5,7.5h25.02L22.78,166.239 c-2.929,2.93-2.929,7.678,0,10.607c1.465,1.464,3.385,2.196,5.304,2.196c1.919,0,3.839-0.732,5.304-2.196L54.734,155.5h35.027 l-15.253,16.394c-2.821,3.032-2.65,7.777,0.383,10.6c1.444,1.344,3.277,2.009,5.106,2.009c0.034,0,0.068-0.005,0.103-0.005 c0.022,0,0.044,0.003,0.065,0.003c0.018,0,0.037,0,0.055,0l22.005-0.125L77.101,209.5H46.5c-4.143,0-7.5,3.357-7.5,7.5 s3.357,7.5,7.5,7.5h15.601l-17.399,17.399c-2.929,2.93-2.929,7.678,0,10.607c1.465,1.464,3.385,2.196,5.304,2.196 c1.919,0,3.672-0.732,5.137-2.196l17.025-17.191V250.5c0,4.143,3.357,7.5,7.5,7.5s7.5-3.357,7.5-7.5v-30.185l25.445-25.278 l0.977,24.39c0.148,4.046,3.517,7.306,7.532,7.225c1.364-0.027,2.844-0.465,4.312-1.543c1.063-0.781,15.734-15.812,15.734-15.812 v35.385l-20.971,21.137c-2.93,2.929-2.846,7.678,0.082,10.607c1.465,1.465,3.425,2.197,5.345,2.197 c1.919,0,3.693-0.732,5.157-2.196l10.387-10.532V290.5c0,4.143,3.357,7.5,7.5,7.5c4.143,0,7.5-3.357,7.5-7.5v-25.31l11.404,11.237 c1.465,1.464,3.468,2.196,5.387,2.196c1.919,0,3.881-0.732,5.345-2.196c2.929-2.93,2.783-7.678-0.146-10.607l-21.99-21.845v-35.7 c0,0,13.729,12.896,15.896,14.976c2.167,2.08,3.942,3.25,6.525,3.25c0.015,0,0.03,0,0.046,0c4.142,0,7.48-3.604,7.455-7.746 l-0.306-23.696l24.384,24.551V250.5c0,4.143,3.357,7.5,7.5,7.5c4.143,0,7.5-3.357,7.5-7.5v-15.891l18.064,17.897 c1.465,1.464,3.467,2.196,5.387,2.196c1.919,0,3.88-0.732,5.345-2.196c2.929-2.93,2.95-7.678,0.021-10.607L236.605,224.5H251.5 c4.143,0,7.5-3.357,7.5-7.5s-3.357-7.5-7.5-7.5h-29.894l-25.742-25.742l23.059-0.831c0.082-0.003,0.162-0.016,0.243-0.021 c0.03-0.002,0.06-0.005,0.09-0.008c3.977-0.319,7.037-3.709,6.892-7.736c-0.087-2.424-1.32-4.531-3.155-5.837L209.138,155.5h34.835 l21.345,21.346c1.465,1.465,3.384,2.197,5.304,2.197c1.919,0,3.839-0.732,5.303-2.196c2.93-2.929,2.93-7.678,0.001-10.606 l-10.74-10.74H289.5c4.143,0,7.5-3.357,7.5-7.5S293.643,140.5,289.5,140.5z M200.795,125.483L186.823,140.5h-19.507l15.002-15.002 L200.795,125.483z M170.21,95.784l0.356,20.002l-14.399,14.315V109.16L170.21,95.784z M127.263,95.865l13.904,13.323v20.205 l-13.925-14.008L127.263,95.865z M96.862,126.444l19.762-0.712l14.768,14.768h-20.299L96.862,126.444z M97.246,169.477 L110.25,155.5h20.851l-13.841,13.841L97.246,169.477z M127.863,201.599l-0.854-21.042l14.158-14.241v21.604L127.863,201.599z M170.819,201.264l-14.652-13.478v-22.179l14.442,14.359L170.819,201.264z M200.991,168.564l-19.614,0.706l-13.77-13.77h20.292 L200.991,168.564z"/> </g> </svg>
// 		`;
		
// 		const arvore = '🎄';
// 		const estrela = '⭐';
// 		const boneco = `
// 			<?xml version="1.0" encoding="utf-8"?> <!-- Generator: Adobe Illustrator 27.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --> <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 800 800"  height="70px" width="70px"> <g id="objects"> <g> <g> <path d="M203.088,436.81c0,0,121.289-218.016,234.086-213.367c52.271,2.155,80.667,54.58,189.018,187.39 c23.68,29.025-73.957,0.844-99.832-13.711c0,0,29.678,71.323,17.55,81.504C521.256,497.642,188.534,470.771,203.088,436.81z"/> <path style="fill:#FF0000;" d="M214.989,431.339c0,0,117.473-205.47,219.314-200.9c52.262,2.345,64.324,43.946,183.472,178.285 c24.855,28.025-78.717-9.817-104.593-24.371c0,0,33.153,80.05,21.025,90.231C511.553,493.6,200.434,465.299,214.989,431.339z"/> <path d="M533.792,394.077c-23.439-14.475-31.93-28.12-58.411-67.336c0,0,39.928,64.925,46.647,80.675 c6.72,15.75-3.59-15.027,0.655-15.027S536.182,395.552,533.792,394.077z"/> <path style="fill:#BA0808;" d="M475.381,326.74c0,0,89.802,82.597,124.642,83.022c0,0-3.117,4.079-3.667,5.668 c-0.417,1.205-47.293-3.131-79.019-31.988C504.21,371.502,484.852,340.772,475.381,326.74z"/> <path d="M460.028,332.805c0,0,24.459,12.937,54.497,60.486C525.396,410.499,497.02,347.764,460.028,332.805z"/> </g> <g> <path d="M556.344,493.337c-0.495-6.746-0.266-11.763-17.707-26.07c-18.356-9.955-32.218-13.512-43.255-14.848 c-3.575-0.434,18.395-3.008,15.385-3.985c-48.516-15.768-95.818-12.332-95.818-12.332l17.284-10.511 c-28.604-7.885-89.09-6.377-115.904-2.459l19.429-9.216c-38.666-1.87-84.902,3.968-107.871,15.085 c-2.298,1.113,1.069-6.262,1.069-6.262l-16.761,4.67c-18.54,6.636-26.521,14.498-27.281,33.827l-0.266,30.723 c-0.547,9.507,11.494,17.166,27.468,13.458c0,0,38.529-8.045,155.166,0.17c110.185,7.761,149.423,34.535,149.423,34.535 c18.271,8.081,28.894-1.364,35.337-19.125L556.344,493.337z"/> <path style="fill:#FFFFFF;" d="M528.875,536.977c-2.731,0-5.852-0.742-9.28-2.21c-2.893-1.851-11.365-8.533-40.852-16.815 c-2.076-0.583,6.857-1.092,6.857-1.092c-17.284-2.426-53.776-10.246-77.602-13.34c-5.678-0.736,14.43-2.911,8.247-3.54 c-7.153-0.728-40.685,0.111-48.537-0.442c-31.446-2.215-80.92,0.038-99.922-9.867c-2.489-1.299,9.185,6.156,6.465,6.156 c-24.087,0-40.298,0.677-50.245,1.937c-9.512,1.206-13.959-3.055-13.428-2.129c2.351,4.093,0.586,3.785,0.298,3.846l-0.132,0.029 c-2.276,0.528-4.515,0.796-6.654,0.796c-4.98,0-9.374-1.504-11.753-4.024c-1.165-1.234-1.715-2.57-1.634-3.974l0.01-0.297 l0.264-30.629c0.62-15.518,8.887-24.977,30.719-31.243l-3.841,7.378c23.752-10.107,37.347-19.779,95.009-19.811 c-0.869,1.197-13.039,11.432-13.039,11.432s49.021-6.378,118.219,0.293c-0.345,0.98-10.979,8.693-10.979,8.693 s27.088,1.414,30.727,1.414c18.132,0,40.48,4.552,55.287,9.047c-5.862,0.758-8.545,3.736-8.667,4.067 c0,0,7.456,1.579,11.333,2.54c13.608,3.373,54.946,16.387,54.501,37.883l-4.103,26.396 c-6.491,17.443-14.537,17.506-17.238,17.506C528.894,536.977,528.884,536.977,528.875,536.977z"/> <path style="fill:#E5E5E5;" d="M542.38,527.54c-5.555,9.388-11.281,9.437-13.476,9.437h-0.037c-2.729,0-5.845-0.752-9.277-2.22 c-2.888-1.843-11.365-8.525-40.85-16.809c-2.074-0.583,6.865-1.092,6.865-1.092c-17.296-2.426-53.779-10.249-77.613-13.342 c-5.676-0.74,14.434-2.912,8.248-3.542c-7.156-0.728-40.68,0.109-48.528-0.437c-31.45-2.22-80.923,0.036-99.929-9.873 c-2.486-1.298,9.182,6.162,6.465,6.162c-24.088,0-40.292,0.679-50.238,1.94c-9.521,1.201-13.96-3.056-13.438-2.134 c2.352,4.087,0.594,3.784,0.303,3.845l-0.134,0.036c-2.28,0.521-4.512,0.788-6.646,0.788c-4.985,0-9.376-1.503-11.753-4.026 c-1.176-1.226-1.722-2.571-1.637-3.967l0.012-0.303l0.255-30.625c0.437-10.71,4.499-18.521,14.143-24.404 c-3.026,2.767-10.606,9.034-9.595,20.151l0.379,24.713l0,0c0.48,3.79,2.412,6.049,3.714,7.126 c3.942,3.259,9.092,2.444,14.077,2.444c2.134,0,4.378-0.267,6.646-0.788l0.134-0.036c0.291-0.061,2.049,0.242-0.291-3.845 c-0.534-0.922,3.917,3.335,13.427,2.134c9.945-1.261,26.149-1.939,50.238-1.939c2.729,0-8.951-7.46-6.465-6.162 c19.006,9.909,68.479,7.653,99.929,9.873c7.847,0.546,44.637,3.15,51.793,3.878c6.174,0.63-11.942,4.718-6.267,5.458 c23.833,3.093,57.562,7.328,74.845,9.754c0,0-9.502,1.843-7.429,2.426c29.498,8.284,36.048,11.863,38.947,13.706 c3.42,1.468,6.537,2.22,9.278,2.22c0,0,0.013,0,0.024,0C539.335,528.086,540.705,528.086,542.38,527.54z"/> </g> <g> <path d="M605.095,470.902c-5.431-4.046-36.53-20.999-24.974-55.587c3.386-10.132,13.794-22.931,20.729-28.708 c0.821-0.684-5.086,14.443-0.303,10.613c15.538-12.441,39.81-23.444,55.914-19.135c1.367,0.365-11.646,7.652-10.29,8.143 c1.887,0.684,26.38,8.642,35.988,29.462c0,0-5.607-4.122-8.688,0.633c-1.833,2.83,6.723,11.623,2.112,34.466 c-2.233,11.067-12.674,28.604-23.56,30.354c0,0,0.815-9.578-1.444-8.624c-26.237,11.081-51.548,7.984-53.772,4.549 C596.574,476.708,608.104,473.147,605.095,470.902z"/> <path style="fill:#FFFFFF;" d="M608.822,474.511c1.157,0.009,3.928-1.543,2.063-3.746c-2.355-2.785-36.885-17.396-24.813-53.705 c1.679-5.053,8.041-16.109,7.688-13.904c-0.38,2.38,0.308,9.543,4.334,4.48c9.447-11.881,31.036-24.835,44.784-24.465 c0.031,0.349-4.611,2.905-3.173,5.335c1.016,1.72,22.305,4.403,37.19,22.769c-4.756-2.631-8.386,1.096-8.268,2.578 c0.654,8.168,6.186,15.753,2.858,32.772c-1.774,9.07-7.771,21.953-13.181,25.268c-0.985-1.39,0.256-6.953-4.077-10.876 c-0.884-0.799-0.013,1.927-4.843,5.596C631.506,480.192,609.646,475.228,608.822,474.511z"/> <path style="fill:#E5E5E5;" d="M672.589,437.448c-0.045,2.924-0.372,6.208-1.128,9.938c-1.849,9.047-7.934,21.897-13.366,25.168 c-0.973-1.401-1.251-7.848-3.069-10.749c-0.253-0.404-0.952,1.77-5.817,5.396c-17.977,13.455-39.798,8.336-40.615,7.615 c1.151,0.008,3.939-1.524,2.087-3.733c-2.212-2.66-33.201-16.129-25.995-48.304c0.181,25.242,25.101,36.229,27.073,38.608 c1.852,2.209-0.927,3.741-2.09,3.731c0.821,0.724,22.651,5.841,40.627-7.613c4.854-3.627,3.983-6.344,4.879-5.557 c2.53,2.225,4.097,9.3,3.999,10.91c5.433-3.273,11.528-16.122,13.366-25.17C672.551,437.606,672.576,437.521,672.589,437.448z"/> </g> </g> </g> </svg>
// 		`;

// 		const snowflakeOptions = [snowflakeSVG, arvore, boneco];
// 		const overlay = $('<div id="snow-overlay"></div>');
// 		$('body').append(overlay);

// 		Função para criar flocos de neve
// 		function createSnowflakes() {
// 			if (snowflakesOnScreen.length < maxVisibleSnowflakes) {
// 				const snowflake = document.createElement("div");
// 				snowflake.classList.add("snowflake");

// 				let elementOption = Math.floor(Math.random() * 5);
				
// 				if( elementOption == 1 ||elementOption == 0){
// 					console.log('floco')
// 					snowflake.innerHTML = snowflakeSVG;
// 					let svgElement = snowflake.querySelector('svg');

// 					/* Flocos de tamanho aleatorio */
// 					let randomHeight = heights[Math.floor(Math.random() * heights.length)];
// 					svgElement.style.setProperty('height', `${randomHeight}px`, 'important');
// 					svgElement.style.setProperty('width', `${randomHeight}px`, 'important');
// 				}else if(elementOption == 2){
// 					snowflake.innerHTML = arvore;
// 					snowflake.style.fontSize = '40px'
					
				
// 				}else if(elementOption == 3){
// 					snowflake.innerHTML = boneco;
// 				}else if(elementOption == 4){
// 					snowflake.innerHTML = estrela;
// 					snowflake.style.fontSize = '35px'
// 				}
			
// 				snowflake.style.left = `${Math.random() * 100}vw`;
// 				snowflake.style.animationDuration = `${Math.random() * 13 + 13}s`;
// 				overlay.append(snowflake);
				
// 				snowflakesOnScreen.push(snowflake);
		
// 			}
// 		}
		
		
// 		function removeAllSnowflakes() {
// 			snowflakesOnScreen.forEach((snowflake) => {
// 				snowflake.style.transition = "opacity 1s, transform 1s";
// 				snowflake.style.opacity = "0";
// 				snowflake.style.transform = "scale(0)";
// 				setTimeout(() => {
// 					snowflake.remove();
// 				}, 1000); // Tempo da animação de fade-out
// 			});

// 			snowflakesOnScreen = [];
// 		}
		
// 		let snowflakeInterval;
// 		Adiciona flocos de neve periodicamente
// 		$(window).on('scroll', () => {
// 			if (!snowflakeInterval){
// 				snowflakeInterval = setInterval(createSnowflakes, 1000);	
				
// 				setTimeout(() => {
// 					clearInterval(snowflakeInterval);
// 					sessionStorage.setItem('animacaoNatal', 'true');
// 					removeAllSnowflakes();
// 					overlay.remove();
// 				}, 13000);

// 				$(window).off('scroll');
// 			} 
	
// 		});
		

// 	}
// });